module.exports = __webpack_public_path__ + "media/images/question-mark-e969d5ab1ea7744f99d7ef4d97720ded.svg";